export default __webpack_public_path__ + "static/media/Commander's Vambraces of Heaven's Pass.a7f92475.jpg";